import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Ellington';

const ELLINGTON_EVENT_NAMES = {
  CLICK_VIEW_MORE: 'media_click_view_more',
  PLAY_MEDIA: 'media_play',
  PAUSE_MEDIA: 'media_pause',
  MEDIA_ERROR: 'media_error',
  LOADED_MEDIA_DATA: 'media_loaded_data',
  LOAD_MEDIA_START: 'media_load_start',
};

export const trackClickViewMore = irpVersion => {
  gspx.trackEvent({
    name: ELLINGTON_EVENT_NAMES.CLICK_VIEW_MORE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MEDIA,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'Click View More button',
      Category: 'Ellington',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackToggleVideoPlay = (id, irpVersion) => {
  gspx.trackEvent({
    name: ELLINGTON_EVENT_NAMES.PLAY_MEDIA,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MEDIA,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Play Media ${id}`,
      Category: 'Ellington',
      'Launched date': new Date(),
      irpVersion,
      mediaId: id,
    },
  });
};

export const trackToggleVideoPause = (id, irpVersion) => {
  gspx.trackEvent({
    name: ELLINGTON_EVENT_NAMES.PAUSE_MEDIA,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MEDIA,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Pause Media ${id}`,
      Category: 'Ellington',
      'Launched date': new Date(),
      irpVersion,
      mediaId: id,
    },
  });
};

export const trackVideoError = (id, irpVersion) => {
  gspx.trackEvent({
    name: ELLINGTON_EVENT_NAMES.MEDIA_ERROR,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MEDIA,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Media Error ${id}`,
      Category: 'Ellington',
      'Launched date': new Date(),
      irpVersion,
      mediaId: id,
    },
  });
};

export const trackVideoLoadedData = (id, irpVersion) => {
  gspx.trackEvent({
    name: ELLINGTON_EVENT_NAMES.LOADED_MEDIA_DATA,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MEDIA,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Loaded Media Data ${id}`,
      Category: 'Ellington',
      'Launched date': new Date(),
      irpVersion,
      mediaId: id,
    },
  });
};

export const trackVideoLoadStart = (id, irpVersion) => {
  gspx.trackEvent({
    name: ELLINGTON_EVENT_NAMES.LOAD_MEDIA_START,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MEDIA,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Load Media Start ${id}`,
      Category: 'Ellington',
      'Launched date': new Date(),
      irpVersion,
      mediaId: id,
    },
  });
};
